import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IMatrizPlanejamentoModel } from 'src/app/models/matriz-planejamento.model';
import { ISubtipoAuditoriaModel } from 'src/app/models/subtipo-auditoria.model';
import { MatrizPlanejamentoService } from 'src/app/services/matriz-planejamento.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-matriz-planejamento-visualizar',
  templateUrl: './matriz-planejamento-visualizar.component.html',
  styleUrls: ['./matriz-planejamento-visualizar.component.scss'],
})
export class MatrizPlanejamentoVisualizarComponent implements OnInit {
  idParam: number;
  public lista: any[] = new Array();

	private originalStyles: Map<HTMLElement, string> = new Map();
	private isPreparingPrint: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private localeService: BsLocaleService,
    private planejamentoService: PlanejamentoService,
  ) { }

  async ngOnInit() {
    this.localeService.use('pt-br');

    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.idParam = parseInt(id, 10);
    }

    await this.obterDados();
  }

	ngAfterViewInit(): void {

		setTimeout(() => {
			this.addDynamicPageBreaks();
			this.setupBrowserSpecificPrint();
		}, 500);
	}

  public async obterDados() {
    try {
      const id = this.route.snapshot.paramMap.get('id');
      const idParam = parseInt(id, 10);
      await this.planejamentoService.obterAbaMatrizUgPorIdImprimir(7, idParam).then((res) => {
        if (res.sucesso) {
          this.lista = this.filtrarUgsElegiveis(res.dados);
			this.ordenarListaPorOrdem();
		  // this.sanitizarHtml();

        }
      }
      );
    } catch (err) {
      this.toastr.error(err.mensagem.descricao, 'Atenção');
      this.router.navigate([`/planejamento/${this.idParam}/planejar`]);
    }
  }

	private filtrarUgsElegiveis(lista: any[]): any[] {
		if (!lista) return [];
		return lista.filter((item: any) => {
			const raw = (item?.statusUg ?? item?.StatusUg);
			const status = (Array.isArray(raw) ? raw.join(' e ') : (raw || '')).trim();
			// Exclui UG exclusivamente "Consultada" — mesma regra da aba Matriz de planejamento
			return status.toLowerCase() !== 'consultada';
		});
	}

	private ordenarListaPorOrdem() {
		this.lista.sort((a, b) => a.ordem - b.ordem);

		this.lista.forEach(matriz => {
			matriz.subtipoAuditoria?.subtipoAuditoriaMatrizPlanejamento?.sort((a, b) =>
				a.matrizPlanejamento.ordem - b.matrizPlanejamento.ordem
			);

			matriz.subtipoAuditoria?.subtipoAuditoriaMatrizPlanejamento?.forEach(sub => {
				sub.matrizPlanejamento?.matrizPlanejamentoQuestaoPlanejamento?.sort((a, b) =>
					a.questao.ordem - b.questao.ordem
				);

				sub.matrizPlanejamento?.matrizPlanejamentoQuestaoPlanejamento?.forEach(q => {
					q.questao?.questaoConstatacao?.sort((a, b) =>
						a.constatacao.ordem - b.constatacao.ordem
					);

					q.questao?.questaoProcedimentoAuditoria?.sort((a, b) =>
						a.procedimentoAuditoria.ordem - b.procedimentoAuditoria.ordem
					);
				});
			});
		});
	}

	shouldBreakBefore(index: number): boolean {
		// Nunca quebrar antes da primeira linha
		if (index === 0) {
			return false;
		}

		// Para tabelas pequenas (até 8 linhas), não quebrar
		// Assumindo que você tem acesso ao total de questões
		const totalQuestoes = this.getTotalQuestoes();
		if (totalQuestoes <= 30) {
			return false;
		}

		// Para tabelas maiores, quebrar a cada 6-7 linhas para otimizar espaço
		// Ajuste este número conforme o tamanho do seu conteúdo
		return index > 0 && index % 30 === 0;
	}

	getTotalQuestoes(): number {
		// Implementar baseado na sua estrutura de dados
		// Exemplo:
		if (this.lista && this.lista.length > 0) {
			const matriz = this.lista[0]; // ou a matriz atual
			if (matriz?.subtipoAuditoria?.subtipoAuditoriaMatrizPlanejamento?.length > 0) {
				return matriz.subtipoAuditoria.subtipoAuditoriaMatrizPlanejamento[0]
					?.matrizPlanejamento?.matrizPlanejamentoQuestaoPlanejamento?.length || 0;
			}
		}
		return 0;
	}

	getTextoLimpo(html: string): string {
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;
		return tempDiv.textContent || tempDiv.innerText || '';
	}
	// print(): void {
	// 	// Aguarda um pequeno delay para garantir que o DOM esteja atualizado
	// 	setTimeout(() => {
	// 		// Remove elementos que podem gerar páginas vazias
	// 		const elementsToHide = document.querySelectorAll('.no-print, hr, .card-footer');
	// 		elementsToHide.forEach((el) => {
	// 			if (el instanceof HTMLElement) {
	// 				el.style.display = 'none';
	// 			}
	// 		});
	//
	// 		// Força altura mínima zero para evitar páginas vazias
	// 		const body = document.body;
	// 		const html = document.documentElement;
	//
	// 		if (body) body.style.minHeight = '0';
	// 		if (html) html.style.minHeight = '0';
	//
	// 		// Adiciona classe específica para impressão (para estilos CSS customizados)
	// 		document.body.classList.add('printing');
	//
	// 		// Executa impressão após pequeno delay
	// 		setTimeout(() => {
	// 			window.print();
	//
	// 			// Restaura elementos e estilos após impressão
	// 			setTimeout(() => {
	// 				// Remove classe de impressão
	// 				document.body.classList.remove('printing');
	//
	// 				// Restaura elementos ocultos
	// 				elementsToHide.forEach((el) => {
	// 					if (el instanceof HTMLElement) {
	// 						el.style.display = '';
	// 					}
	// 				});
	//
	// 				// Restaura alturas mínimas
	// 				if (body) body.style.minHeight = '';
	// 				if (html) html.style.minHeight = '';
	// 			}, 1000);
	// 		}, 100);
	// 	}, 100);
	// }
	print(): void {
		// Aguardar um tick para garantir que o Angular atualizou o DOM
		setTimeout(() => {
			// Aplicar classe para forçar layout de impressão se necessário
			const tables = document.querySelectorAll('.matriz-tabela');
			const shouldForceScale = this.checkIfTableNeedsScaling();

			if (shouldForceScale) {
				tables.forEach(table => table.classList.add('force-no-break'));
			}

			window.print();

			// Remover a classe após impressão
			if (shouldForceScale) {
				setTimeout(() => {
					tables.forEach(table => table.classList.remove('force-no-break'));
				}, 100);
			}
		}, 0);
	}

	private checkIfTableNeedsScaling(): boolean {
		const totalQuestoes = this.getTotalQuestoes();
		// Se tem mais de 12 questões ou conteúdo muito extenso, aplicar escala
		return totalQuestoes > 12;
	}
	private calculateQuestionsPerPage(questoes: any[]): number {
		// Estimativa baseada no tamanho médio do conteúdo
		const avgContentLength = questoes.reduce((acc, questao) => {
			let totalLength = 0;
			totalLength += questao.questao.nome?.length || 0;
			totalLength += questao.questao.legislacaoAplicavelCriterio?.length || 0;
			totalLength += questao.questao.questaoConstatacao?.reduce((acc: number, c: any) =>
				acc + (c.constatacao.nome?.length || 0), 0) || 0;
			return acc + totalLength;
		}, 0) / questoes.length;

		// Página A4 landscape comporta aproximadamente 6-10 questões dependendo do conteúdo
		if (avgContentLength > 500) return 6;
		if (avgContentLength > 300) return 8;
		return 10;
	}

	/**
	 * Adiciona controle de quebra de página dinâmico
	 */
	private addDynamicPageBreaks(): void {
		const matrices = document.querySelectorAll('.matriz-container');

		matrices.forEach(matriz => {
			const rows = matriz.querySelectorAll('.table-row');
			const questionsPerPage = 8; // Valor padrão

			rows.forEach((row, index) => {
				if (index > 0 && index % questionsPerPage === 0) {
					row.classList.add('break-before-row');
				}
			});
		});
	}

	/**
	 * Configurações específicas para diferentes navegadores
	 */
	private setupBrowserSpecificPrint(): void {
		// Detectar navegador
		const isChrome = /Chrome/.test(navigator.userAgent);
		const isFirefox = /Firefox/.test(navigator.userAgent);
		const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

		if (isChrome) {
			// Configurações específicas para Chrome
			document.documentElement.style.setProperty('--print-zoom', '0.8');
		} else if (isFirefox) {
			// Configurações específicas para Firefox
			document.documentElement.style.setProperty('--print-zoom', '0.85');
		} else if (isSafari) {
			// Configurações específicas para Safari
			document.documentElement.style.setProperty('--print-zoom', '0.9');
		}
	}

	private optimizeLargeTables(): void {
		const tables = document.querySelectorAll('.matriz-tabela');

		tables.forEach(table => {
			const rows = table.querySelectorAll('tbody tr');

			if (rows.length > 15) {
				// Para tabelas muito longas, adiciona quebras mais frequentes
				rows.forEach((row, index) => {
					if (index > 0 && index % 6 === 0) {
						row.classList.add('break-before-row');
					}
				});
			}
		});
	}

	public cancelar() {
		this.router.navigate(
			[`/planejamento/${this.idParam}/planejar`],
			{ queryParams: { aba: 7 } }
		);
	}
}
